<template>
  <nav class="admin-tabs" aria-label="Admin sections">
    <RouterLink
      v-for="t in tabs"
      :key="t.name"
      :to="{ name: t.name }"
      class="tab"
      active-class="tab--active"
      exact-active-class="tab--active"
    >
      <span class="tab-label">{{ t.label }}</span>
    </RouterLink>
  </nav>
</template>

<script setup lang="ts">
import { RouterLink } from "vue-router";

const tabs = [
  { name: "admin", label: "Users" },
  { name: "admin-onboard", label: "Onboard project" },
  { name: "admin-senders", label: "Reminder senders" },
] as const;
</script>

<style scoped>
.admin-tabs {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  margin-top: 16px;
  background: var(--bg-elev);
  border: 1px solid var(--line);
  border-radius: 12px;
}
.tab {
  display: inline-flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--ink-2);
  text-decoration: none;
  transition: background var(--speed-quick) var(--ease), color var(--speed-quick) var(--ease);
}
.tab:hover { background: var(--bg-tint); color: var(--ink-1); }
.tab--active {
  background: var(--brand-soft);
  color: var(--brand);
}
.tab-label {
  font-family: "JetBrains Mono", monospace;
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
</style>
